var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8387_69767)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8387_69767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8387_69767)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0768 3.01978C15.4184 2.19848 16.5818 2.19848 16.9234 3.01977L19.9976 10.4109C20.1416 10.7572 20.4672 10.9937 20.841 11.0237L28.8204 11.6634C29.7071 11.7345 30.0666 12.841 29.391 13.4197L23.3116 18.6274C23.0268 18.8713 22.9024 19.2541 22.9894 19.6189L24.8468 27.4054C25.0532 28.2706 24.1119 28.9545 23.3528 28.4908L16.5214 24.3182C16.2013 24.1227 15.7989 24.1227 15.4788 24.3182L8.64737 28.4908C7.88827 28.9545 6.94702 28.2706 7.15341 27.4054L9.01078 19.6189C9.09779 19.2541 8.97342 18.8713 8.68863 18.6274L2.60916 13.4197C1.93363 12.841 2.29315 11.7345 3.1798 11.6634L11.1592 11.0237C11.533 10.9937 11.8586 10.7572 12.0026 10.4109L15.0768 3.01978Z",
    fill: "#E5E7EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8387_69767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8387_69767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0768 3.01978C15.4184 2.19848 16.5818 2.19848 16.9234 3.01977L19.9976 10.4109C20.1416 10.7572 20.4672 10.9937 20.841 11.0237L28.8204 11.6634C29.7071 11.7345 30.0666 12.841 29.391 13.4197L23.3116 18.6274C23.0268 18.8713 22.9024 19.2541 22.9894 19.6189L24.8468 27.4054C25.0532 28.2706 24.1119 28.9545 23.3528 28.4908L16.5214 24.3182C16.2013 24.1227 15.7989 24.1227 15.4788 24.3182L8.64737 28.4908C7.88827 28.9545 6.94702 28.2706 7.15341 27.4054L9.01078 19.6189C9.09779 19.2541 8.97342 18.8713 8.68863 18.6274L2.60916 13.4197C1.93363 12.841 2.29315 11.7345 3.1798 11.6634L11.1592 11.0237C11.533 10.9937 11.8586 10.7572 12.0026 10.4109L15.0768 3.01978Z",
    fill: "#FBBF24"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8387_69767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.17f7c9ff903d02bc3988149e33d28c22.svg";
export { ForwardRef as ReactComponent };